var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.547,
    height: 19.888,
    viewBox: "0 0 17.547 19.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6c757d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.226 0.159)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225.909,12.2,218.153,4.44A1.166,1.166,0,1,0,216.5,6.089l7.758,7.757a1.165,1.165,0,0,0,1.648-1.648Z",
    transform: "translate(-216.163 -4.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.17 3.22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.315,82.9l-.058.293a12.526,12.526,0,0,1-2.762,5.6l4.22,4.22a12.484,12.484,0,0,1,5.568-2.79l.293-.058Z",
    transform: "translate(-137.494 -82.905)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.982)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.532,256.989l-2.884,2.884a1.748,1.748,0,0,0,0,2.472l1.648,1.648a1.748,1.748,0,0,0,2.472,0l2.884-2.884Zm.412,4.532a.583.583,0,0,1-.824-.824l.824-.824a.583.583,0,0,1,.824.824Z",
    transform: "translate(-30.136 -256.989)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.28 13.443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195.482,349.928l.793-.793a1.746,1.746,0,0,0,0-2.472l-.589-.589a11.036,11.036,0,0,0-.938.709l.7.7a.581.581,0,0,1,0,.823l-.806.806-1.184-1.147-1.648,1.648,2.644,2.562a1.165,1.165,0,0,0,1.647-1.649Z",
    transform: "translate(-191.813 -346.075)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.447,0a.582.582,0,0,0-.583.583V1.748a.583.583,0,1,0,1.165,0V.583A.582.582,0,0,0,332.447,0Z",
    transform: "translate(-331.864)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.216 4.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M423.612,120h-1.165a.583.583,0,0,0,0,1.165h1.165a.583.583,0,1,0,0-1.165Z",
    transform: "translate(-421.864 -120)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.051 1.165)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M394.024,30.17a.582.582,0,0,0-.824,0l-1.165,1.165a.583.583,0,1,0,.824.824l1.165-1.165A.582.582,0,0,0,394.024,30.17Z",
    transform: "translate(-391.864 -30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.f6652e3ccb9be10141ab329b40daf393.svg";
export { ForwardRef as ReactComponent };